import {
  Text,
  List,
  ListItem,
  ListIcon,
  Flex,
  Button,
  Center,
  Box,
} from "@chakra-ui/react";
import { AddIcon, CheckIcon } from "@chakra-ui/icons";
import { FiUnlock } from "react-icons/fi";
import { useRouter } from "next/router";
import { textStyle } from "theme/names";

const plans = [
  { id: "start", text: "Starter" },
  { id: "grow", text: "Standard" },
  { id: "enterprise", text: "Pro" }
];

interface UpgradePopupProps {
  currentPlan: string;
  feature: string;
  availablePlans: string[];
}

export function UpgradePopup({ currentPlan, feature, availablePlans }: UpgradePopupProps) {
  const router = useRouter();

  const planOptions = availablePlans?.map(id => plans.find(p => p.id === id)?.text).join(' or ');
  return (
    <Center>
      <Box
        background="linear-gradient(96.86deg, #000000 3.49%, #144462 94.63%)"
        color="white"
        textAlign="center"
        borderRadius="2xl"
        position="absolute"
        top="calc(30vh)"
        zIndex="100"
        fontSize="xs"
        py="6"
        px={{ base: "8", sm: "20" }}
      >
        <Text textStyle={textStyle["body.medium.light"]} color="white" fontSize="md">
          You are on <b>{plans.find(p => p.id === currentPlan)?.text}</b>
        </Text>
        <Text textStyle={textStyle["body.medium.light"]} fontSize="md" color="white" fontWeight="medium" mt="1">
          Upgrade to <b>{planOptions}</b> to use
        </Text>
        <Text textStyle={textStyle["body.medium.light"]} fontSize="lg" color="white" fontWeight="bold" mt="1">
          {feature}
        </Text>
        <Button
          size="sm"
          leftIcon={<FiUnlock />}
          color="#1E1E1E"
          background="white"
          mt="5"
          fontWeight="bold"
          onClick={() => router.push("/pricing")}
        >
          UNLOCK
        </Button>
      </Box>
    </Center>
  );
}
